import { render, staticRenderFns } from "./MobileAppBanner.vue?vue&type=template&id=bd031834&scoped=true"
import script from "./MobileAppBanner.vue?vue&type=script&lang=js"
export * from "./MobileAppBanner.vue?vue&type=script&lang=js"
import style0 from "./MobileAppBanner.vue?vue&type=style&index=0&id=bd031834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd031834",
  null
  
)

export default component.exports